import { render, staticRenderFns } from "./LicenseReminder.vue?vue&type=template&id=34c348fe&"
import script from "./LicenseReminder.vue?vue&type=script&lang=js&"
export * from "./LicenseReminder.vue?vue&type=script&lang=js&"
import style0 from "./LicenseReminder.vue?vue&type=style&index=0&id=34c348fe&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports